import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Guests/PublicSearchGenerals/Get`, payload),
    GetByID: (payload) => Repository.post(`/api/Guests/PublicSearchGenerals/GetByID`, payload),
}
